import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { formatDate as _formatDate, formatDateMedium as _formatDateMedium, formatDateShort as _formatDateShort, formatDatetimeLong as _formatDatetimeLong, formatDatetimeMedium as _formatDatetimeMedium, formatTimeHourMinute as _formatTimeHourMinute, formatDecimal2FractionDigits as _formatDecimal2FractionDigits, formatDecimal2MinIntegerNoFraction as _formatDecimal2MinIntegerNoFraction, formatPercentMax2FractionDigits as _formatPercentMax2FractionDigits, formatNumber as _formatNumber, formatPlain as _formatPlain } from '@instructure/quiz-i18n';
import getLocale from './locale';
import getTimezone from './timezone';
export var withI18nSupport = function withI18nSupport(WrappedComponent) {
  return /*#__PURE__*/function (_WrappedComponent) {
    function I18nAwareComponent() {
      _classCallCheck(this, I18nAwareComponent);
      return _callSuper(this, I18nAwareComponent, arguments);
    }
    _inherits(I18nAwareComponent, _WrappedComponent);
    return _createClass(I18nAwareComponent, [{
      key: "locale",
      get: function get() {
        return getLocale(this.props, this.context);
      }
    }, {
      key: "timezone",
      get: function get() {
        return getTimezone(this.props, this.context);
      }
    }, {
      key: "formatDatetimeLong",
      value: function formatDatetimeLong(value) {
        return _formatDatetimeLong(value, this.locale, this.timezone);
      }
    }, {
      key: "formatDateMedium",
      value: function formatDateMedium(value) {
        return _formatDateMedium(value, this.locale, this.timezone);
      }
    }, {
      key: "formatDateShort",
      value: function formatDateShort(value) {
        return _formatDateShort(value, this.locale, this.timezone);
      }
    }, {
      key: "formatDatetimeMedium",
      value: function formatDatetimeMedium(value) {
        return _formatDatetimeMedium(value, this.locale, this.timezone);
      }
    }, {
      key: "formatTimeHourMinute",
      value: function formatTimeHourMinute(value) {
        return _formatTimeHourMinute(value, this.locale, this.timezone);
      }
    }, {
      key: "formatPlain",
      value: function formatPlain(value) {
        return _formatPlain(value, this.locale);
      }
    }, {
      key: "formatDecimal2MinIntegerNoFraction",
      value: function formatDecimal2MinIntegerNoFraction(value) {
        return _formatDecimal2MinIntegerNoFraction(value, this.locale);
      }
    }, {
      key: "formatDecimal2FractionDigits",
      value: function formatDecimal2FractionDigits(value) {
        return _formatDecimal2FractionDigits(value, this.locale);
      }
    }, {
      key: "formatPercentMax2FractionDigits",
      value: function formatPercentMax2FractionDigits(value) {
        return _formatPercentMax2FractionDigits(value, this.locale);
      }
    }, {
      key: "formatDate",
      value: function formatDate(value, format) {
        return _formatDate(value, this.locale, this.timezone, format);
      }
    }, {
      key: "formatNumber",
      value: function formatNumber(value, format) {
        return _formatNumber(value, this.locale, format);
      }
    }]);
  }(WrappedComponent);
};
export default withI18nSupport;